import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "emoji-picker-tab" }

import vue from '../../../../adapter-vue';
import {
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  TUITranslateService
} from '../../../../@aidesk/uikit-engine';
import { isPC, isH5 } from '../../../../utils/env';
import { IEmojiGroupList, IEmojiGroup } from '../../../../interface';
import { isEnabledMessageReadReceiptGlobal } from '../../../../utils/utils';
import {
  EMOJI_GROUP_LIST,
  BASIC_EMOJI_URL_MAPPING,
  convertKeyToEmojiName,
  BASIC_EMOJI_URL,
  filterEmojisInNonChineseEnv,
} from '../../emoji-config';

export default /*@__PURE__*/_defineComponent({
  __name: 'emoji-picker-dialog',
  emits: ['insertEmoji', 'onClose', 'sendMessage'],
  setup(__props, { emit: __emit }) {

const { ref, onMounted, onUnmounted } = vue;

const emits = __emit;
const currentConversation = ref();
const emojiPickerDialog = ref();
const emojiPickerListRef = ref();
const list = ref<IEmojiGroupList>(EMOJI_GROUP_LIST);
const currentEmojiList = ref<string[]>(list?.value[0]?.list);

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
  currentEmojiList.value = filterEmojisInNonChineseEnv(list.value[0].list);
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

const select = (item: any, index: number) => {
  const options: any = {
    emoji: { key: item, name: convertKeyToEmojiName(item) },
    type: 'basic',
  };
  options.url = BASIC_EMOJI_URL + BASIC_EMOJI_URL_MAPPING[item];
  emits('insertEmoji', options);
  isPC && emits('onClose');
};

const sendFaceMessage = (index: number, listItem: IEmojiGroup) => {
  const options = {
    to:
      currentConversation?.value?.groupProfile?.groupID
      || currentConversation?.value?.userProfile?.userID,
    conversationType: currentConversation?.value?.type,
    payload: {
      index: listItem.emojiGroupID,
      data: listItem.list[index],
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  } as SendMessageParams;
  TUIChatService.sendFaceMessage(options);
};

function sendMessage() {
  emits('sendMessage');
}

function onCurrentConversationUpdate(conversation: IConversationModel) {
  currentConversation.value = conversation;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "emojiPickerDialog",
    ref: emojiPickerDialog,
    class: _normalizeClass({
      'emoji-picker': true,
      'emoji-picker-h5': !_unref(isPC),
    })
  }, [
    _createElementVNode("ul", {
      ref_key: "emojiPickerListRef",
      ref: emojiPickerListRef,
      class: _normalizeClass(['emoji-picker-list', !_unref(isPC) && 'emoji-picker-h5-list'])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentEmojiList), (childrenItem, childrenIndex) => {
        return (_openBlock(), _createElementBlock("li", {
          key: childrenIndex,
          class: "emoji-picker-list-item",
          onClick: ($event: any) => (select(childrenItem, childrenIndex))
        }, [
          _createElementVNode("img", {
            class: "emoji",
            src: _unref(BASIC_EMOJI_URL) + _unref(BASIC_EMOJI_URL_MAPPING)[childrenItem]
          }, null, 8, _hoisted_2)
        ], 8, _hoisted_1))
      }), 128))
    ], 2),
    _createElementVNode("ul", _hoisted_3, [
      (_unref(isH5))
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "send-btn",
            onClick: sendMessage
          }, _toDisplayString(_unref(TUITranslateService).t("发送")), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})